<template>
  <div class="eleara1 section-container" :class="{'dark':skinType}"
    style="
      display: flex;
      justify-content: space-around;
    "
  >
    <template v-if="TongJi">
      <div class="smalldiv d-flex flex-grow-1 justify-content-around">
        <div class="useele-item d-flex align-items-center">
          <span class="use-ele-icon iconfont iconjintian"></span>
          <div class="d-flex flex-column" style="margin-left:12px;">
            <span>今日用电量(kWh)：</span>
            <div class="decText ele-today">{{ TongJi.Today }}</div>
          </div>
        </div>
        <div class="useele-item d-flex align-items-center">
          <span class="use-ele-icon iconfont iconrili"></span>
          <div class="d-flex flex-column" style="margin-left:12px;">
           <span> 昨日用电量(kWh)：</span>
           <span
            class="decText ele-lastday"
            >{{ TongJi.LastToday }}</span
          >
          </div>
        </div>
        <div class="useele-item d-flex align-items-center">
          <span class="use-ele-icon iconfont iconbenyue"></span>
          <div class="d-flex flex-column" style="margin-left:12px;">
            <div>本月用电量(kWh)：</div>
            <span
            class="decText ele-cur-month"
            >{{ TongJi.CurMonth }}</span
          >
           </div>
        </div>
      </div>
    <!-- <div class="moreBu">
      <el-button type="primary" plain size="small" @click="queryMoreListener"
        >查询更多 >></el-button
      >
    </div> -->
    </template>
    <no-data-temporarily v-else></no-data-temporarily>
  </div>
</template>

<script>
import { ele1 } from '@/api/ele-situation/ele1';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import TurnAskingMixin from '@/mixins/turn-ask';

export default {
  mixins: [TurnAskingMixin],
  data() {
    return {
      TongJi: null,
      dialogVisible: false,
      options: [
        {
          value: '日',
          label: '日',
        },
        {
          value: '月',
          label: '月',
        },
      ],
      value: '日',
      time1: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      month1: '',
      year1: '',
      isSM: false,
      isST: true,
      tableData: [
      ],
    };
  },
  components: {
    NoDataTemporarily,
  },
  props: {
    proId: {
      type: String,
    },
  },
  watch: {
    proId(a) {
      this.requestData(a);
    },
    value(a) {
      if (a === '日') {
        this.isSM = false;
        this.isST = true;
      } else {
        this.isSM = true;
        this.isST = false;
      }
    },

  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    requestData(a) {
      ele1({
        ProjectIdStr: a,
      })
        .then((res) => {
          this.TongJi = res.TongJi;
        })
        .catch(() => {
          this.TongJi = null;
        }).then(() => {
          this.turnAsking({
            routeName: this.routeName,
            nowRouteName: this.$route.name,
            func: () => { this.requestData(a); },
          });
        });
    },
    // 跳转至数据查询界面
    queryMoreListener() {
      this.$router.replace(
        {
          name: 'query-pivot',
        },
      );
    },
  },
};
</script>
<style  scoped>
.gao {
  height: 100%;
}
.use-ele-icon{
  font-size: 3.6rem;
  color:#65C5FC;
}
.ele-today{
  color: #4EF0A4;
}
.ele-lastday{
  color:#F0954E;
}
.ele-cur-month{
  color:#F25789;
}
.logtiaojian {
  width: 100%;
  display: flex;
  align-items: center;
}
.logbiao {
  width: 100%;
  height: 100%;
  background: chartreuse;
  display: flex;
}

.decText {
  font-size: 1rem;
  margin-top: 0.6rem;
  font-size: 1.6rem;
}
.moreBu {
  height: 100%;
  display: flex;
  align-items: center;
}
.nini {
  height: 30%;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-left: 2%;
}
</style>
